var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSpanner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2 6.1c-.2 0-.4.1-.6.3l-2.8 2.8L14.7 7l2.8-2.8c.2-.2.4-.2.4-.5 0-.2 0-.2-.2-.4-2.2-1.1-4.8-.5-6.5 1.2-1.5 1.5-2 3.6-1.5 5.6l-7.6 7.6c-.3.3-.3.8 0 1.1l2.9 3c.3.3.8.3 1.1 0l7.6-7.6c2 .6 4.2 0 5.6-1.5 1.7-1.7 2.3-4.2 1.3-6.4-.2-.2-.2-.2-.4-.2z"
  })));
}

export default SvgSpanner;